// import { useTheme } from "styled-components";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    // const { isDark } = useTheme();
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 43 43"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-1",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#0AC5F7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#50D0B7",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        x1: "83.8040865%",
                        y1: "50%",
                        x2: "-1.11022302e-14%",
                        y2: "50%",
                        id: "linearGradient-2",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#50D0B7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#00C3FF",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "兑换首页",
                    transform: "translate(-1443.000000, -28.000000)",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "编组-16",
                        transform: "translate(187.000000, 0.000000)",
                        children: /*#__PURE__*/ _jsx("g", {
                            id: "Frame-45",
                            transform: "translate(1111.000000, 25.000000)",
                            children: /*#__PURE__*/ _jsxs("g", {
                                id: "swap_icon_qianbao",
                                transform: "translate(146.000000, 4.000000)",
                                children: [
                                    /*#__PURE__*/ _jsx("rect", {
                                        id: "路径",
                                        stroke: "url(#linearGradient-1)",
                                        x: "0",
                                        y: "0",
                                        width: "41",
                                        height: "41",
                                        rx: "20.5"
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        id: "qianbaoyue",
                                        transform: "translate(10.000000, 12.000000)",
                                        fill: "url(#linearGradient-2)",
                                        fillRule: "nonzero",
                                        children: /*#__PURE__*/ _jsx("path", {
                                            d: "M14.3478261,0 C15.9326432,0 17.2173913,1.28474811 17.2173913,2.86956522 L19.1304348,2.86956522 C20.7152519,2.86956522 22,4.15431333 22,5.73913043 L22,6.69565217 L15.7826087,6.69565217 C14.1977916,6.69565217 12.9130435,7.98040028 12.9130435,9.56521739 C12.9130435,11.1500345 14.1977916,12.4347826 15.7826087,12.4347826 L15.7826087,12.4347826 L22,12.4347826 L22,15.3043478 C22,16.8891649 20.7152519,18.173913 19.1304348,18.173913 L2.86956522,18.173913 C1.28474811,18.173913 0,16.8891649 0,15.3043478 L0,2.86956522 C0,1.28474811 1.28474811,0 2.86956522,0 L14.3478261,0 Z M15.7826087,8.13043478 C16.5750172,8.13043478 17.2173913,8.77280885 17.2173913,9.56521739 C17.2173913,10.3576259 16.5750172,11 15.7826087,11 C14.9902001,11 14.3478261,10.3576259 14.3478261,9.56521739 C14.3478261,8.77280884 14.9902001,8.13043478 15.7826087,8.13043478 Z M14.3478261,1.43478261 L2.86956522,1.43478261 C2.10982027,1.43474029 1.48174562,2.02695492 1.43717391,2.7853913 L1.43478261,2.86956522 L15.7826087,2.86956522 C15.7826087,2.10982027 15.1904364,1.48174562 14.432,1.43717391 L14.3478261,1.43478261 Z",
                                            id: "形状结合"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
